import $ from 'jquery';

// make sub navigation wider for new pages (new grid)
let columnWidth = $("[data-page$='-new']").length ? 193.6 : 192;

/**
 * @see REBOOT-15193
 */
export function setSubMenuHeight() {
    var $placeholder = $('#main-sub-menu');
    var $rows = $placeholder.find('.navigation--rows');
    var $teaser = $placeholder.find('.navigation--teaser img');
    var rowsHeight = $rows.outerHeight();
    var teaserHeight = $teaser.height() + 3;

    if (rowsHeight > teaserHeight) {
        $placeholder.height(rowsHeight);

    } else {
        $placeholder.height(teaserHeight);
    }

    $rows.find('.navigation--row').each(function () {
        var $row = $(this);
        var height = -1;

        /*
         * Find max height of cells
         */
        $row.find('.navigation--cell-wrapper').each(function () {
            var $cell = $(this);
            var cellHeight = $cell.height();

            if (cellHeight > height) {
                height = cellHeight;
            }
        });

        $row.find('.navigation--cell-wrapper').height(height);
    });

}

export function setSubmenuVerticalPosition(arrowX) {

    var $subMenu = $('#main-sub-menu');
    var $arrow = $subMenu.find('>.arrow');
    var iArrowGrid = Math.floor(arrowX / 192);
    var iMenuWidth = 0;
    var iLeftColumn;
    var iOffset;

    if ($subMenu.find('.navigation--teaser').length > 0) {
        iMenuWidth++;
    }

    iMenuWidth += $subMenu.find('.navigation--row:first .navigation--cell-wrapper').length;

    /*
     When I have width, alter view to match
     */
    $subMenu.width(columnWidth * iMenuWidth);
    $subMenu.find('.navigation--row').width(columnWidth * iMenuWidth);

    iLeftColumn = Math.round(iArrowGrid + 1 - (iMenuWidth / 2));

    if (iLeftColumn < 0) {
        iLeftColumn = 0;
    }
    if (iLeftColumn + iMenuWidth > 5) {
        iLeftColumn = 5 - iMenuWidth;
    }

    if (iLeftColumn > iArrowGrid) {
        iLeftColumn = iArrowGrid;
    }

    iOffset = columnWidth * iLeftColumn;

    $subMenu.css('left', iOffset + 'px');
    $arrow.css('left', arrowX - iOffset + 'px');
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/modules/common/mainmenu-layout.js
 **/